import React from 'react';
import HeroSection from './HeroSection';
import BlogPosts from './BlogPosts';
import JoinTheClub from '../HomePage/JoinTheClub';

const BlogPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Main Content */}
      <main>
        <HeroSection />
        <BlogPosts />
        <JoinTheClub />
      </main>
    </div>
  );
};

export default BlogPage;
